<template>
    <div style="display: contents;">
        <tr>
            <td :style="{ paddingLeft: 10 + (25 * level) + 'px' }">
                {{ item.name }}
            </td>
            <td>{{ item.type !== CATEGORY_LABEL ? item.type : '' }}</td>
            <td>{{ item.type !== CATEGORY_LABEL ? item.description : '' }}</td>
            <td>{{ item.type !== CATEGORY_LABEL ? item.sales_price : '' }}</td>
            <td><input type="checkbox" disabled :checked="item.type !== CATEGORY_LABEL ? (item.sales_tax === 'taxable') : false" /></td>
            <td>
                <div class="dropdown" v-if="item.type !== CATEGORY_LABEL">
                    <a href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-ellipsis-v"></i>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button class="dropdown-item" @click="edit(item, item.type, 'edit')">Edit</button>
                        <button class="dropdown-item" @click="edit(item, item.type, 'duplicate')">Duplicate</button>
                        <button class="dropdown-item" @click="remove(item, item.type)">Delete</button>
                    </div>
                </div>
            </td>
        </tr>
        <pg-product-and-services-nested-listing v-if="item.children.length > 0" v-for="child in item.children" :key="child.id" :item="child" :level="level + 1" />
    </div>
</template>

<script>

export default {
    name: 'pg-product-and-services-nested-listing',
    props: ['item', 'level'],
    data() {
        return {
            CATEGORY_LABEL: 'category',
            PRODUCT_LABEL: 'product',
            SERVICE_LABEL: 'service',
            BUNDLE_LABEL: 'bundle',
        }
    },
    methods: {
        edit(item, label, type) {
            Bus.$emit('edit-product-services', item, label, type);
        },
        remove(item, label) {
            Bus.$emit('open-remove-product-services-modal', item, label);
        }
    }
}
</script>
